module.exports = {"id":"138247","name":"Kevin Stuhr-Ellegaard","rating":"72","photo":"./data/images/photos/0/138247.png","club":{"name":"IF Elfsborg","logo":"./data/images/clubs/IFElfsborg.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinStuhr-Ellegaard0.json
// module id = 2355
// module chunks = 0